export default {
  en: {
    title: 'Anything goes',
    subtitle: 'No script, just like a real conversation.',
  },
  ru: {
    title: 'О чём угодно',
    subtitle: 'Без сценария, как в настоящем разговоре.',
  },
  de: {
    title: 'Alles erlaubt',
    subtitle: 'Kein Skript, einfach wie ein echtes Gespräch.',
  },
  pt: {
    title: 'Sobre o que quiser',
    subtitle: 'Sem roteiro, como numa conversa de verdade.',
  },
  fr: {
    title: 'Tout est permis',
    subtitle: 'Pas de script, comme dans une vraie conversation.',
  },
  es: {
    title: 'De lo que quieras',
    subtitle: 'Sin guion, como en una conversación de verdad.',
  },
};
